import { render, staticRenderFns } from "./CartPriceCard.vue?vue&type=template&id=2daa92e6&scoped=true&"
import script from "./CartPriceCard.vue?vue&type=script&lang=js&"
export * from "./CartPriceCard.vue?vue&type=script&lang=js&"
import style0 from "./CartPriceCard.vue?vue&type=style&index=0&id=2daa92e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2daa92e6",
  null
  
)

export default component.exports